import * as React from 'react'
import { useFormikContext } from 'formik'
import { LocAndSvcsFormModel } from '../formConfig'
import { useSchedulingWizard } from '../../wizardContext'
import { useCallback, useEffect } from 'react'

export function useData() {
  const [{ canClose, requireACWOppsSchedulingService }] = useSchedulingWizard()
  const {
    setFieldValue,
    values: { closeWin: value },
  } = useFormikContext<LocAndSvcsFormModel>()

  useEffect(() => {
    if (requireACWOppsSchedulingService && canClose) {
      setFieldValue('closeWin', 'close')
    }
  }, [canClose, requireACWOppsSchedulingService, setFieldValue])

  const onChange = useCallback(
    (_e: React.ChangeEvent<HTMLInputElement>, value: string) =>
      setFieldValue('closeWin', value),
    [setFieldValue],
  )

  return {
    value,
    canClose,
    onChange,
    requireACWOppsSchedulingService,
  }
}
